<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入活动场所"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.search.searchDate" />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 数据请求
import { loadActivityDispatchSignInfoListDataApi, loadActivityDispatchSignInfoExportDataApi } from '@/api/activityDispatch'
export default {
  name: 'ActivityDispatchSignInfo',
  components: {
    CustomTable,
    TableOperation,
    DateSelect
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'activity_dispatch_sign_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['activity_dispatch_sign_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            storeName: '',
            searchDate: 'month',
            status: 2
          }
        }
      },
      id: null, // 选中的单据ID
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'bill.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 'bill.city_name', width: 80 },
      { prop: 'realStoreName', label: '活动场所', filterColumn: 's.real_store_name', width: 160 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'scheme.name', width: 160 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'scheme.project_no', width: 160 },
      { prop: 'dispatchName', label: '任务名称', filterColumn: 'bill.name', width: 160 },
      { prop: 'activityTypeStr', label: '活动类型', filterColumn: '(case bill.activity_type when 1 then \'品鉴活动\' when 2 then \'品牌推广\' else \'\' end)', width: 110 },
      { prop: 'activityDateStr', label: '活动时间', filterColumn: 'info.activity_date', width: 110, isBetween: true },
      { prop: 'activityTimeStr', label: '活动时间段', filterColumn: '(case info.activity_time when 1 then \'上午\' when 2 then \'下午\' when 3 then \'晚上\' else \'\' end)', width: 120 },
      { prop: 'workHour', label: '工作时长', filterColumn: 'info.work_hour', width: 120 },
      { prop: 'isCancelStr', label: '是否取消', filterColumn: '(case info.is_cancel when 1 then \'是\' else \'否\' end)', width: 130 },
      { prop: 'userName', label: '签到签退人', filterColumn: 'info.user_name', width: 120 },
      { prop: 'isIgnoreStr', label: '是否忽略', filterColumn: '(case info.is_ignore when 1 then \'是\' else \'否\' end)', width: 130 },
      { prop: 'ignoreReason', label: '忽略原因', filterColumn: 'info.ignore_reason', width: 150 },
      { prop: 'ignoreTimeStr', label: '忽略时间', filterColumn: 'info.ignore_time', width: 140, isBetween: true },
      { prop: 'isSignInStr', label: '是否签到', filterColumn: '(case info.is_sign_in when 1 then \'是\' else \'否\' end)', width: 110 },
      { prop: 'signInTimeStr', label: '签到时间', filterColumn: 'info.sign_in_time', width: 140, isBetween: true },
      { prop: 'signInAddress', label: '签到地点', filterColumn: 'info.sign_in_address', width: 160 },
      { prop: 'signInDistance', label: '签到偏差', filterColumn: 'info.sign_in_distance', width: 110 },
      { prop: 'isSignOutStr', label: '是否签退', filterColumn: '(case info.is_sign_out when 1 then \'是\' else \'否\' end)', width: 110 },
      { prop: 'signOutTimeStr', label: '签退时间', filterColumn: 'info.sign_out_time', width: 140, isBetween: true },
      { prop: 'signOutAddress', label: '签退地点', filterColumn: 'info.sign_out_address', width: 160 },
      { prop: 'signOutDistance', label: '签退偏差', filterColumn: 'info.sign_out_distance', width: 110 }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadActivityDispatchSignInfoListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadActivityDispatchSignInfoExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
